export default {"src":"/_next/static/media/dental-blue.e06f4542.svg","height":34,"width":119,"blurWidth":0,"blurHeight":0};